import { Observable, of } from "rxjs";
import { ApiService } from "./../api-service/api.service";
import { Injectable } from "@angular/core";
import { NAVIGATE_ROUTES } from "../../global/constants";
import { UserDetailsService } from "../user-details.service";

@Injectable({
  providedIn: "root",
})
export class GetNewMemberService {
  apiEndPoint = NAVIGATE_ROUTES;
  res: any[] = [];
  company_id: any;

  constructor(
    private apiService: ApiService,
    public userDetail: UserDetailsService
  ) {}
  async getCompanyID() {
    this.company_id = await this.userDetail.getCompanyId();
    return this.company_id;
  }

  async getStaffMember(page = 1, count = 25): Promise<Observable<any>> {
    const company_id = await this.getCompanyID();
    this.res.length = 0;
    const url = `${this.apiEndPoint.GET_MEMBER}?companyId=${company_id}&userType=employee&page=${page}&count=${count}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res.length = 0;
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getStaffMember2(company_id: any): Promise<Observable<any>> {
    this.res.length = 0;
    const url = `${this.apiEndPoint.GET_MEMBER}?companyId=${company_id}&userType=employee`;
    await this.apiService.get(url).then((resData: any) => {
      this.res.length = 0;
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getCoMember(page = 1, count = 25): Promise<Observable<any>> {
    const company_id = await this.getCompanyID();
    this.res.length = 0;
    const url = `${this.apiEndPoint.GET_MEMBER}?companyId=${company_id}&userType=outsider&page=${page}&count=${count}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getPendingMember(page = 1, count = 25): Promise<Observable<any>> {
    const company_id = await this.getCompanyID();
    const url = `${this.apiEndPoint.GET_MEMBER}?companyId=${company_id}&userType=invitee&page=${page}&count=${count}`;
    await this.apiService.get(url).then((resData: any) => {
      this.res.length = 0;
      this.res = [];
      this.res = resData;
    });
    return of(this.res);
  }

  async getStaffMemberInCompany(page = 1, count = 10): Promise<Observable<any>> {
    return this.getStaffMember(page, count);
  }

  async getCoMemberInCompany(page = 1, count = 10): Promise<Observable<any>> {
    return this.getCoMember(page, count);
  }

  async getPendingMemberInCompany(page = 1, count = 10): Promise<Observable<any>> {
    return this.getPendingMember(page, count);
  }
}
